import { navigateTo, useRoute } from '#imports';
import { storeToRefs } from 'pinia';
import { apiGetLoggedInUserInfo, apiLogin } from '~/api/auth';
import { resolveDefaultLandingUrl } from '~/composables/use-default-landing-url';
import { useAccountStore } from '~/store/account';
import { useAuthUserStore } from '~/store/auth-user';
import { useOrganizationStore } from '~/store/organization';
import { getFirstQueryParam } from '~/utils/common';

export const useCompleteLogin = () => {
  const route = useRoute();
  const authUserStore = useAuthUserStore();
  const accountStore = useAccountStore();
  const { organization } = storeToRefs(useOrganizationStore());

  return async (input: {
    idToken: string;
    rawUserInfo?: Record<string, unknown>;
    loginMethod: string;
  }) => {
    await apiLogin(input.idToken, input.rawUserInfo);

    authUserStore.authUser = await apiGetLoggedInUserInfo();
    await accountStore.setCurrentAccount();

    // Link analytics data to user for accurate journey tracking
    const { identifyUser } = await import('~/utils/posthog');
    if (authUserStore.authUser) {
      identifyUser(authUserStore.authUser, input.loginMethod);
    }

    const redirect = getFirstQueryParam(route.query.redirect);

    if (
      organization.value?.isBusinessesEnabled &&
      organization.value.organizationSettings?.businessSelectorEnabled
    ) {
      return navigateTo({
        path: '/business-selection',
        query: redirect ? { redirect } : {},
      });
    }

    return navigateTo(redirect ?? resolveDefaultLandingUrl(organization.value));
  };
};
